import { render, staticRenderFns } from "./commonHead.vue?vue&type=template&id=033f4e36&scoped=true"
import script from "./commonHead.vue?vue&type=script&lang=js"
export * from "./commonHead.vue?vue&type=script&lang=js"
import style0 from "./commonHead.vue?vue&type=style&index=0&id=033f4e36&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033f4e36",
  null
  
)

export default component.exports